var CONSTANTS = require('./deep-link-constants'),
    CONSTANTS2 = require('./deep-link-constants2'),
    CONSTANTS3 = require('./deep-link-constants3'),
    MODELS = require('./deep-link-models'),
    MODELS2 = require('./deep-link-models2'),
    arrayFind = require('array-find');
var oem = {
    dodge: {
        link: 'http://www.dodge.com/',
        message: 'www.dodge.com',
        build: buildDodge
    },
    lexus: {
        link: 'http://www.lexus.com/build-your-lexus/#!/series/',
        message: 'www.lexus.com',
        build: buildLexus
    },
    nissan: {
        link: 'https://www.nissanusa.com/buildyournissan/modelLine/build/',
        message: 'www.nissan',
        'message-van': 'NissanCommercialVehicles.com',
        build: buildNissan
    },
    chevrolet: {
        link: 'http://www.chevrolet.com/',
        message: 'www.chevrolet.com',
        build: buildChevrolet
    }
};

function buildLexus(data) {
    var model = data.model.split('-')[0].toUpperCase();
    if(data.model.indexOf('h') !== -1) {
        model += 'h';
    }
    var code = data.code;
    code = code.replace(/^9335$/, '9313');
    code = code.replace(/^9225$/, 'v9202F');
    var lexusLink = oem[data.niceName].link + model + '/year/' + data.year + '/trim/' + code + '/buildId/111';
    var trackingURL = (CONSTANTS.TRACKING[data.niceName][data.model]) ? CONSTANTS.TRACKING[data.niceName][data.model].link + '?' : '';

    if(data.intColor) {
        lexusLink += '/interior-colors/my-dream-car/{-x-:-' + data.extColor + '-,-i-:-' + data.intColor + '-,-a-:[],-p-:[],-z-:[]}';
    }

    return trackingURL + encodeURI(lexusLink);
}
function buildNissan(data) {
    var idArray = MODELS.model.nissan;
    var code;

    code = arrayFind(idArray, function (modelId) {
        return (modelId.niceName.toLowerCase().replace(/ /g, '-') == data.model) && (modelId.submodel == data.submodel);
    }).id;
    code = code || data.code;

    var nissanLink = 'http://www.nissancommercialvehicles.com/build/model/' + code,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? (CONSTANTS2.TRACKING[data.niceName][data.model].link + '?') : '';

    checkNissanLink(data,code,nissanLink);

    return trackingURL + encodeURI(nissanLink);
}
function checkNissanLink(data,code,nissanLink) {
    if(code.toLowerCase().indexOf('nv') == -1) {
        nissanLink = oem[data.niceName].link + data.year  + '/' + code;
    }
    if(code == 'nv200-taxi') {
        nissanLink = 'http://www.nissancommercialvehicles.com/nv200-taxi';
    }
    return {
        nissanLink: nissanLink
    };
}
function buildChevrolet(data) {
    var chevroletLink = oem[data.niceName].link;
    var idArray = MODELS.model.chevrolet;
    var submodel;

    submodel = arrayFind(idArray, function (modelId) {
        return modelId.niceName.toLowerCase().replace(/ /g, '-') == data.model;
    }).id;

    submodel = submodel || data.submodel;

    if(data.year  == '2016') { chevroletLink += '2016-'; }
    chevroletLink += submodel + '/build-your-own.html#/trim';

    var trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(chevroletLink);
}
function buildDodge(data) {
    if(data.model == 'grand-caravan' && data.year == '2016' && window.location.search.indexOf('story-id=ncas-373') == -1) {
        return null;
    }
    if(window.location.search.indexOf('story-id=ncas-373') > -1) {
        var dodgeLink = oem[data.niceName].link + 'hostc/bmo/CUD';
        var idArray = MODELS2.model.dodge;
        var id, code, llp;
        idArray.map(function (val) {
            if(val.niceName == data.model) {
                id = val.id; 
                code = val.code;
                llp = val.llp;
            }
        });
        dodgeLink += data.year + id + '/models.do';
        if(data.year == '2016') {
            return dodgeLink;
        }
        return dodgeLink + '?ccode=CUD' + data.year + id + code + '&llp=' + llp;
    }

    var dodgeInfo = getDodgeInfo(data);
    return dodgeInfo.trackingURL + encodeURI(dodgeInfo.vehicleLink);
}
function getDodgeInfo(data) {
    var vehicleLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year== '2017') {
        vehicleLink += data.year + '/' + data.model  + '/index.html';
    } else {
        vehicleLink += 'en/' + data.model.replace(/-/g, '_');
    }

    if (data.year == '2017' && data.model == 'grand-caravan') {
        var conquestMake = 'chrysler',
            conquestModel = 'pacifica';
        trackingURL = (CONSTANTS3.TRACKING[conquestMake]['conquest'][data.niceName]) ?
            CONSTANTS3.TRACKING[conquestMake]['conquest'][data.niceName][data.model].link + '?' : '';
        oem[data.niceName].message = oem[conquestMake].message;
        vehicleLink = oem[conquestMake].link + '?family=' + conquestModel + '&year=' +  data.year;
    }

    return {
        trackingURL: trackingURL,
        vehicleLink: vehicleLink
    };
}

module.exports = {
    oem3: oem,
    buildLexus: buildLexus,
    buildNissan: buildNissan,
    buildChevrolet: buildChevrolet,
    buildDodge: buildDodge
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-data3.js
// module id = 186
// module chunks = 0 1 23